<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_a"></a>More Advance Praise for<br/><strong><em>Last Dog on the Hill</em></strong></p>
<p class="para1">“Steve Duno describes Lou and himself as ‘neither dog nor human but family, just family.’ Anyone who has ever loved with their heart wide open will want to come along for this ride. Unpredictable, heroic, and funny… just like Lou.”</p>
<p class="right-para">—Monica Holloway, author of <em>Cowboy &amp; Wills: A Love Story</em></p>
<p class="para1">“Anyone who has ever loved or lost a dog, or both, will be touched by this spellbinding story about two beings who crossed the human-animal divide and met on the other side.”</p>
<p class="right-para">—Stefan Bechtel, author of<br/><em>DogTown: Tales of Rescue, Rehabilitation, and Redemption</em></p>
<p class="para1">“There are so many accounts and testaments that verify beyond doubt that a dog is man’s best friend. What makes this story special is that Lou, in terms of fate, was destined for a rough and unspectacular life. Lou and Steve found each other by sheer chance. Lou’s life was richer for being Steve’s dog, but the real twist of fate is how Steve’s life and the lives of all those who knew Lou were enriched forever.”</p>
<p class="right-para">—Nuala Gardner, author of<br/><em>A Friend Like Henry: The Remarkable True Story<br/>of an Autistic Boy and the Dog That Unlocked His World</em></p>
<p class="para1">“Steve Duno manages to inspire and touch the heart in a story about a hero dog that is, quite frankly, impossible to forget.”</p>
<p class="right-para">—Mandy Stadtmiller, <em>New York Post</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?74a72b65